export const isInAppBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Check for Facebook/Instagram in-app browser
  if (userAgent.indexOf('FBAN') > -1 || userAgent.indexOf('FBAV') > -1) return true;
  if (userAgent.indexOf('Instagram') > -1) return true;
  
  // Check for other common in-app browsers
  if (userAgent.indexOf('Line') > -1) return true;
  
  return false;
}; 